<mat-card class="cardWithShadow theme-card" style="margin-bottom: 10px;margin-top: -20px;">
    <mat-card-header>
      <button mat-flat-button color="primary" (click)="volver()">
        <i-tabler class="custom-icon" name="arrow-left"></i-tabler>
        <span class="button-text">Volver</span>
      </button>
    </mat-card-header>
  </mat-card>


<mat-card class="cardWithShadow theme-card">
    <mat-card-content class="b-t-1">
        <div class="row">
            <div class="col-md-6">

                <div class="row">
                    <h4> Datos del Perfil</h4>
                </div>


                <div class="row mt-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Nombre del Perfil</mat-label>
                        <input matInput [(ngModel)]="profile.nombre" name="nombre" (ngModelChange)="updateProfile()" />
                    </mat-form-field>
                </div>
                

                <div class="row mt-2">

                    <button #ignoredButton class="btn btn-primary" (click)="toggle=!toggle" style="width: 200px;"> Seleccionar Color</button>

                    <input #ignoredInput
                        [style.background]="color"
                        [cpIgnoredElements]="[ignoredButton, ignoredInput]"
                        [(cpToggle)]="toggle"
                        [(colorPicker)]="color"
                        (colorPickerChange)="colorChanged($event)"
                        style="width: 100px;border: none; margin-left: 10px;"/>     

                </div>

                <div class="row mt-2">

                    <button #ignoredBackgroundButton class="btn btn-primary" (click)="toggleFondo=!toggleFondo" style="width: 200px;"> Seleccionar Color de Fondo</button>

                    <input #ignoredBackgroundInput
                        [style.background]="colorFondo"
                        [cpIgnoredElements]="[ignoredBackgroundButton, ignoredBackgroundInput]"
                        [(cpToggle)]="toggleFondo"
                        [(colorPicker)]="colorFondo"
                        (colorPickerChange)="colorFondoChanged($event)"
                        style="width: 100px;border: none; margin-left: 10px;"/>     

                </div>

                <div class="row mt-2">

                    <button #ignoredButton class="btn btn-primary" (click)="toggleLetra=!toggleLetra" style="width: 200px;"> Seleccionar Color Letras</button>

                    <input #ignoredInput
                        [style.background]="colorLetras"
                        [cpIgnoredElements]="[ignoredButton, ignoredInput]"
                        [(cpToggle)]="toggleLetra"
                        [(colorPicker)]="colorLetras"
                        (colorPickerChange)="colorLetrasChanged($event)"
                        style="width: 100px;border: none; margin-left: 10px;"/>     

                </div>

                <div class="row mt-2">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showLogo" (change)="toggleChangedShowLogo($event.checked)">
                        <label class="custom-upload-label"> Mostrar Logo</label>
                    </mat-slide-toggle>

                        
                    <div class="upload-container" *ngIf="profile?.showLogo">
                        <label for="imgLogoUpload" class="custom-upload-label">Imagen Logo:</label>
                        <input
                        id="imgLogo"
                        type="file"
                        (change)="onFileChange($event, 'imgLogo')"
                        accept="image/*"
                        class="custom-upload-input"
                        />

                        <input
                        type="range"
                        min="20"
                        max="200"
                        step="1"
                        [(ngModel)]="profile.logoHeight"
                        />
                        <span>Tamaño</span>
                    </div>
                   
                </div>
                

                <div class="row mt-3">
                    <div class="upload-container">
                        <label for="imgUpload" class="custom-upload-label">Imagen Principal (banner):</label>
                        <input
                        id="imgUpload"
                        type="file"
                        (change)="onFileChange($event, 'img')"
                        accept="image/*"
                        class="custom-upload-input"
                        />

                        <input
                        type="range"
                        min="20"
                        max="300"
                        step="1"
                        [(ngModel)]="profile.bannerHeight"
                        />
                        <span>Tamaño</span>

                    </div>
                </div>

                
                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showSave" (change)="toggleChangedShowSave($event.checked)">
                        <label class="custom-upload-label">Mostrar Boton Guardar</label>
                    </mat-slide-toggle>
                </div>

                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showAddress" (change)="toggleChangedShowAddress($event.checked)">
                        <label class="custom-upload-label"> Mostrar Dirección</label>
                    </mat-slide-toggle>
                </div>

                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showButtonCall" (change)="toggleChangedShowButtonCall($event.checked)">
                        <label class="custom-upload-label"> Mostrar Boton Llamar </label>
                    </mat-slide-toggle>
                </div>

                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showButtonWSP" (change)="toggleChangedShowButtonWSP($event.checked)">
                        <label class="custom-upload-label"> Mostrar Boton WhatsApp </label>
                    </mat-slide-toggle>
                </div>

                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showButtonMail" (change)="toggleChangedShowButtonMail($event.checked)">
                        <label class="custom-upload-label"> Mostrar Boton Correo </label>
                    </mat-slide-toggle>
                </div>


                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showDivisor" (change)="toggleChangedDivisor($event.checked)">
                        <label class="custom-upload-label"> Mostrar Linea Divisoria</label>
                    </mat-slide-toggle>
                </div>

                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showButtonComponent" (change)="toggleChangedButtonComponent($event.checked)">
                        <label class="custom-upload-label"> Mostrar Comoponente Botones</label>
                    </mat-slide-toggle>

                    <div *ngIf="profile?.showButtonComponent" class="upload-container">
                        <label class="custom-upload-label"> Configurar Botones</label>

                        <div *ngFor="let btn of profile?.buttons; let i = index" class="mb-2 card p-3">
                          <input type="text" placeholder="Título" [(ngModel)]="btn.title" class="form-control my-1">
                          <input type="text" placeholder="Link" [(ngModel)]="btn.link" class="form-control my-1">
                      
                          <select [(ngModel)]="btn.type" class="form-select my-1">
                            <option value="full">Completo</option>
                            <option value="outline">Bordes</option>
                          </select>
                      
                          <button class="btn btn-danger btn-sm" (click)="removeButton(i)">Eliminar</button>
                        </div>
                      
                        <button class="btn btn-success btn-sm my-2" (click)="addButton()">Agregar Botón</button>
                      
                      </div>
                </div>

                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showTexto" (change)="toggleChangedShowTexto($event.checked)">                        
                        <label class="custom-upload-label">Mostrar Texto</label>
                    </mat-slide-toggle>

                    <div *ngIf="profile?.showTexto" class="mt-2 upload-container ">
                        <div class="w-100" style="margin-bottom: 16px;">
                          <label class="mat-label" style="display:block;margin-bottom:4px;">Texto</label>
                          <ckeditor *ngIf="isBrowser && Editor"
                            [editor]="Editor"
                            [(ngModel)]="profile.texto"
                            (ngModelChange)="updateTexto($event)"
                            name="texto"
                          ></ckeditor>
                        </div>
                          
                    </div>
                      
                   
                </div>

                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showRSComponent" (change)="toggleChangedRSComponent($event.checked)">                        
                        <label class="custom-upload-label">Mostrar Comoponente Redes Sociales</label>
                    </mat-slide-toggle>

                    <div *ngIf="profile?.showRSComponent" class="mt-2 upload-container ">
                        <label class="custom-upload-label">Configurar Redes Sociales</label>
                      
                        <div *ngFor="let red of profile?.redes; let i = index" class="mb-2 card p-3">
                          <select [(ngModel)]="red.tipo" (ngModelChange)="updateProfile()" class="form-select my-1">
                            <option value="facebook">Facebook</option>
                            <option value="instagram">Instagram</option>
                            <option value="twitter">Twitter</option>
                            <option value="linkedin">LinkedIn</option>
                            <option value="youtube">YouTube</option>
                            <option value="tiktok">TikTok</option>
                            <option value="promo">Promociones</option>
                          </select>
                      
                          <input type="text" placeholder="Link" [(ngModel)]="red.link" (ngModelChange)="updateProfile()" class="form-control my-1" />
                      
                          <button class="btn btn-danger btn-sm" (click)="removeRedSocial(i)">Eliminar</button>
                        </div>
                      
                        <button class="btn btn-success btn-sm my-2" (click)="addRedSocial()">Agregar Red Social</button>
                      </div>
                      
                   
                </div>

                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showVideo" (change)="toggleChangedShowVideo($event.checked)">
                        <label class="custom-upload-label">Mostrar Video</label>
                    </mat-slide-toggle>

                    <div *ngIf="profile?.showVideo" class="mt-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Url Video</mat-label>
                            <input matInput [(ngModel)]="profile.video" name="video" (ngModelChange)="updateProfile()" />
                        </mat-form-field>
                    </div>
                </div>


                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showWSPForm" (change)="toggleChangedShowWSPForm($event.checked)">
                        <label class="custom-upload-label">Mostrar Fomulario contacto</label>
                    </mat-slide-toggle>
                    <div *ngIf="profile?.showWSPForm" class="mt-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Texto Boton</mat-label>
                            <input matInput [(ngModel)]="profile.textoButtonForm" name="textoForm" (ngModelChange)="updateProfile()" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Titulo ultimo campo</mat-label>
                            <input matInput [(ngModel)]="profile.textoForm" name="textoForm" (ngModelChange)="updateProfile()" />
                        </mat-form-field>
                    </div>
                </div>

                
                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showQR" (change)="toggleChangedShowQR($event.checked)">
                        <label class="custom-upload-label">Mostrar QR</label>
                    </mat-slide-toggle>
                </div>
                
                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showFooter" (change)="toggleChangedShowFooter($event.checked)">
                        <label class="custom-upload-label">Mostrar Conectar</label>
                    </mat-slide-toggle>
                </div>

                <div class="row">
                    <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="profile.showFooterTienda" (change)="toggleChangedShowFooterTienda($event.checked)">
                        <label class="custom-upload-label">Mostrar Banner Tienda</label>
                    </mat-slide-toggle>
                </div>

                <button mat-flat-button color="primary" (click)="guardarPerfil()">Guardar</button>
                
            </div>
            <div class="col-md-6" style="    min-width: 460px;">
                <div class="row">
                    <div>
                        <app-tarjeta [profile]="profile" ></app-tarjeta>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
